import { Fragment, memo } from 'react';
import { BatchEditConfirm } from './BatchEditConfirm';
import { BatchEditForm } from './BatchEditForm';

export const BatchEditModal = memo(() => {
  return (
    <Fragment>
      <BatchEditForm />
      <BatchEditConfirm />
    </Fragment>
  );
});
BatchEditModal.displayName = 'BatchEditModal';
